import { getApiInstance } from './api.helpers';
import { normalizeDate } from './date.helpers';
export const isOutsideVisitWindowRange = (date, visit) => {
    if (!visit.c_window_start_date || !visit.c_window_end_date) {
        return false;
    }
    const today = normalizeDate(date);
    const windowStartDate = normalizeDate(visit.c_window_start_date);
    const windowEndDate = normalizeDate(visit.c_window_end_date);
    return today < windowStartDate || today > windowEndDate;
};
export const getParticipantVisitScheduleData = async ({ environment, participantId, siteId, locale, }) => {
    return await getApiInstance(environment, locale).get(`/v2/routes/c_sites/${siteId}/c_public_users/${participantId}/c_visit_schedule`, {
        params: {
            expand: ['c_anchor_date_template'],
        },
    });
};
export const getVisitActivityResponsesData = async ({ environment, participantId, accountId, siteId, visitId, groupId, responseId, }) => {
    return await getApiInstance(environment).get(`v2/accounts/${accountId}/c_sites/${siteId}/c_task_responses`, {
        params: {
            sort: JSON.stringify({ _id: -1 }),
            where: JSON.stringify({
                'c_public_user._id': participantId,
                ...(visitId ? { 'c_visit._id': visitId } : { 'c_group._id': groupId }),
                ...(responseId ? { _id: responseId } : {}),
            }),
            expand: ['c_step_responses.c_step', 'c_task', 'c_event', 'c_public_user'],
        },
    });
};
